/*━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━*/

/**
 * modules.js
 */

/*━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━*/
/**
 * Import module.
 */
import { smoothScrollTo } from "./smoothScrollTo";
import { setDNavBtn } from "./setDNavBtn";
import { setCreateSpan } from "./setCreateSpan";
import { tabSelecterHover } from "./setTabSelecter";
import { setAcdnMenu } from "./setAcdnMenu";
import { setScrollTrigger } from "./setScrollTrigger";
import { setSplash } from "./setSplash";
import "./add/setDataCountUp";
import { defaultSlider } from "./setSlider";

/**
 * Do modules.
 */
function modules() {
  smoothScrollTo();
  setDNavBtn();
  setCreateSpan();
  tabSelecterHover();
  setAcdnMenu();
  setSplash();
  setScrollTrigger();
  defaultSlider();
}

export { modules };
